import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import Flex from '../Flex';
import { GridRowContext } from './context';
import { GRID_COLUMNS, GRID_GUTTER, GRID_SPACING } from './constants';
import { justifyContent } from '../style/flex-justify';
import { alignItems } from '../style/flex-align';
import { marginVerticalHalfNegative } from '../style/margin-vertical-negative';
import { marginHorizontalHalfNegative } from '../style/margin-horizontal-negative';
var StyledFlex = styled(Flex)(_templateObject(), function (_ref) {
  var $gutter = _ref.$gutter;
  return marginHorizontalHalfNegative($gutter);
}, function (_ref2) {
  var $spacing = _ref2.$spacing;
  return marginVerticalHalfNegative($spacing);
}, function (_ref3) {
  var $alignX = _ref3.$alignX;
  return $alignX && justifyContent($alignX);
}, function (_ref4) {
  var $alignY = _ref4.$alignY;
  return $alignY && alignItems($alignY);
});

var GridRow = function GridRow(_ref5) {
  var _ref5$gutter = _ref5.gutter,
      gutter = _ref5$gutter === void 0 ? GRID_GUTTER : _ref5$gutter,
      _ref5$spacing = _ref5.spacing,
      spacing = _ref5$spacing === void 0 ? GRID_SPACING : _ref5$spacing,
      _ref5$columns = _ref5.columns,
      columns = _ref5$columns === void 0 ? GRID_COLUMNS : _ref5$columns,
      alignX = _ref5.alignX,
      alignY = _ref5.alignY,
      props = _objectWithoutPropertiesLoose(_ref5, ["gutter", "spacing", "columns", "alignX", "alignY"]);

  return /*#__PURE__*/React.createElement(GridRowContext.Provider, {
    value: {
      gutter: gutter,
      spacing: spacing,
      columns: columns
    }
  }, /*#__PURE__*/React.createElement(StyledFlex, _extends({
    flexShrink: 1,
    flexGrow: 0,
    flexWrap: true,
    flexBasis: "auto",
    boxSizing: "border-box",
    $gutter: gutter,
    $spacing: spacing,
    $alignX: alignX,
    $alignY: alignY
  }, props)));
};

export default GridRow;